import {
  Maybe,
  PanelInput,
  Operation,
} from '../../../__generated__/globalTypes'

import {
  LayoutFragment,
  layoutFragmentString,
} from '../../fragments/__generated__/LayoutFragment'

import createOrUpdateBackPanelRawString from '../CreateOrUpdateBackPanel.graphql'

const createOrUpdateBackPanelString = [
  createOrUpdateBackPanelRawString,
  layoutFragmentString,
].join('\n\n')

export type CreateOrUpdateBackPanelData = {
  createOrUpdateBackPanel: {
    layout: Maybe<LayoutFragment>
  }
}

export type CreateOrUpdateBackPanelVariables = {
  panel: PanelInput
  layoutId: string
}

export type CreateOrUpdateBackPanel = Operation<
  CreateOrUpdateBackPanelData,
  CreateOrUpdateBackPanelVariables
>

export const CreateOrUpdateBackPanel = ({
  panel,
  layoutId,
}: CreateOrUpdateBackPanelVariables): CreateOrUpdateBackPanel => ({
  query: createOrUpdateBackPanelString,
  variables: {
    panel: PanelInput(panel),
    layoutId,
  },
})
